import { mapMutations, mapGetters, mapActions } from "vuex";
import {} from "@/store/mutation-types";

import StarRating from "vue-star-rating";
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "product-mobile",
    props: ["sliders", "items"],
    data() {
        return {
            currentSlide: 0,
        };
    },
    computed: {
        ...mapGetters({
            basket: `basket/basket`,
            count: `basket/count`,
            popupFastBuy: `card/popupFastBuy`,
            isAuthenticated: `auth/isAuthenticated`,
        }),
    },
    components: {
        StarRating,
        Carousel,
        Slide,
    },
    methods: {
        ...mapActions({
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
        }),
        ...mapMutations({
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        addToBasket(product) {
            this.addBasket({
                min_price: this.product.min_price,
                select_count: this.count,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.item.id,
                count: this.item.select_count ? this.item.select_count : 1,
            });
        },
        addFavourites(item) {
            if (this.isAuthenticated) {
                this.addFavourite(item)
                    .then(() => {
                        this.$toasted.success(this.$t("successAddFavourites"));
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log(this.validationErrors);
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        changeArrow(value) {
            const carousel = this.$refs["slider-items"];
            const currentPage = carousel.currentPage;
            const pageCount = carousel.pageCount;
            if (value === "prev") {
                currentPage !== 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
            } else {
                currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
            }
        },
        gotToSlide(index) {
            const carousel = this.$refs["slider-items"];
            carousel.goToPage(index);
        },
        pageChange(slide) {
            this.currentSlide = slide;
        },
    },
};
